/**
 * Small helpers for a slot's group-keyed maps (fixed lists, ranks, own
 * amounts): drop one group, keep only one, keep the groups still on the
 * drop. An empty map is null, as the API stores it.
 * For Media Devoted | Created By Ciro Autiero
 */
type GroupMap = Record<string, number> | null | undefined;

const orNull = (map: Record<string, number>) => (Object.keys(map).length ? map : null);

export function dropKey(map: GroupMap, groupId: string): Record<string, number> | null {
  const next = { ...(map ?? {}) };
  delete next[groupId];
  return orNull(next);
}

export const onlyKey = (map: GroupMap, groupId: string): Record<string, number> | null =>
  map?.[groupId] !== undefined ? { [groupId]: map[groupId] } : null;

export const keepKeys = (map: GroupMap, groupIds: string[]): Record<string, number> | null =>
  orNull(Object.fromEntries(Object.entries(map ?? {}).filter(([g]) => groupIds.includes(g))));
